<template>
  <div class="w-full">
    <vx-input-group v-if="hasValidators">
      <ValidationProvider :name="label" rules="required|noBeforeToday" v-slot="{ errors }">
        <vs-input :label="label" v-model="inputData" @input="handleInput" type="date" :min="minExpectedDate" :max="maxExpectedDate" class="w-full" />
        <p class="text-danger" style="text-align: center;">{{ errors[0] }}</p>
      </ValidationProvider>
    </vx-input-group>
    <vx-input-group v-else>
        <vs-input :label="label" v-model="inputData" @input="handleInput" type="date" :min="minExpectedDate" :max="maxExpectedDate" class="w-full" />
    </vx-input-group>
  </div>
</template>
<script>

export default {
  name: 'CalendarInput',
  props: {
      value: {
        type: String | undefined,
        required: true
      },
      minDate: {
        type: String | undefined,
        required: false,
      },
      maxDate: {
        type: String | undefined,
        required: false,
      },
      label: {
        type: String | undefined,
        required: true
      },
      dateFromCurrent: {
        type: Boolean,
        required: false,
        default: true
      },
      hasValidators: {
        type: Boolean,
        required: false,
        default: true
      }
  },
  data () {
    const MAX_TIMESTAMP = 8640000000000000;
    return {
      minExpectedDate: this.minDate ? this.minDate : this.dateFromCurrent ? new Date().toISOString().split('T')[0] : '',
      maxExpectedDate: this.maxDate ? this.maxDate : new Date(MAX_TIMESTAMP).toISOString().split('T')[0],
      inputData: this.value
    };
  },
  methods: {
    handleInput () {
      this.$emit('input', this.inputData)
    }
  },
  watch: {
    minDate (minDate) {
      this.minExpectedDate = minDate;
    },
    maxDate (maxDate) {
      this.maxExpectedDate = maxDate;
    }
  }
};
</script>
<style></style>
